import { Container } from "inversify";
import "reflect-metadata";
import {
  CPLAuthenticationClient,
  CPLCalendarEventsClient,
  CPLChangeTrackingClient,
  CPLClientsClient,
  CPLDevelopmentsClient,
  CPLDocumentSubTypesClient,
  CPLDocumentTypesClient,
  CPLJobTypesClient,
  CPLLegalEntitiesClient,
  CPLPurchaseAccountInformationClient,
  CPLSLATypesClient,
  CPLStandardDescriptionsClient,
  CPLSystemInfoClient,
  CPLUserTasksClient,
  CPLUsersClient,
  CPLWorkingHoursClient,
  ICPLCalendarEventsClient,
  ICPLAuthenticationClient,
  ICPLChangeTrackingClient,
  ICPLClientsClient,
  ICPLDevelopmentsClient,
  ICPLDocumentSubTypesClient,
  ICPLDocumentTypesClient,
  ICPLJobTypesClient,
  ICPLLegalEntitiesClient,
  ICPLPurchaseAccountInformationClient,
  ICPLSLATypesClient,
  ICPLStandardDescriptionsClient,
  ICPLSystemInfoClient,
  ICPLUserTasksClient,
  ICPLUsersClient,
  ICPLWorkingHoursClient,
  ICPLUsersSupervisorsClient,
  CPLUsersSupervisorsClient,
  ICPLTextEditorImageUploadClient,
  CPLTextEditorImageUploadClient,
  ICPLCaseTypesClient,
  CPLCaseTypesClient,
  CPLCaseStatusTypesClient,
  ICPLCaseStatusTypesClient,
  ICPLCasesClient,
  CPLCasesClient,
  CPLMeetingTypesClient,
  ICPLMeetingTypesClient,
  CPLMeetingsClient,
  ICPLMeetingsClient,
  CPLDirectorsClient,
  ICPLDirectorsClient,
  CPLAddressesClient,
  ICPLAddressesClient,
  ICPLCommentsClient,
  CPLCommentsClient,
  ICPLCPLCoreConnectClient,
  CPLCPLCoreConnectClient,
  ICPLDashboardClient,
  CPLDashboardClient,
  ICPLJobsClient,
  CPLJobsClient,
  ICPLEstimatesClient,
  CPLEstimatesClient,
  CPLSettingsClient,
  ICPLSettingsClient,
  ICPLPaymentProvidersClient,
  CPLPaymentProvidersClient,
  ICPLPowerBIClient,
  CPLPowerBIClient,
  ICPLTestClient,
  CPLTestClient,
  CPLBackgroundServiceClient,
  ICPLBackgroundServiceClient,
  ICPLAIChatClient,
  CPLAIChatClient,
  ICPLAIInvoicesClient,
  CPLAIInvoicesClient,
  ICPLWebNarrativesClient,
  CPLWebNarrativesClient,
  ICPLCPL3SettingsClient,
  CPLCPL3SettingsClient,
  ICPLDirectDebitCollectionDaysClient,
  CPLDirectDebitCollectionDaysClient,
  CPLResumableProcessClient,
  ICPLResumableProcessClient,
  CPLServiceChargeInvoicingClient,
  ICPLServiceChargeInvoicingClient,
  CPLServiceChargeInvoicingSettingsClient,
  ICPLServiceChargeInvoicingSettingsClient,
  ICPLBlocksClient,
  CPLBlocksClient,
  ICPLFundSchedulesClient,
  CPLFundSchedulesClient,
  ICPLAnticipatedExpenditureClient,
  CPLAnticipatedExpenditureClient,
  CPLServiceChargeInvoicingSummariesClient,
  ICPLServiceChargeInvoicingSummariesClient,
  ICPLFundHeaderClient,
  CPLFundHeaderClient,
  ICPLSelfServeDataImportSubmissionsClient,
  CPLSelfServeDataImportSubmissionsClient,
  ICPLSelfServeDataImportSubmissionFilesClient,
  CPLSelfServeDataImportSubmissionFilesClient,
  ICPLSelfServeDataImportSubmissionSheetMappingsClient,
  CPLSelfServeDataImportSubmissionSheetMappingsClient,
  ICPLSelfServeDataImportSubmissionColumnMappingsClient,
  CPLSelfServeDataImportSubmissionColumnMappingsClient,
  ICPLSelfServeDataImportSubmissionValidationResultsClient,
  CPLSelfServeDataImportSubmissionValidationResultsClient,
  ICPLSelfServeDataImportSubmissionEditsClient,
  CPLSelfServeDataImportSubmissionEditsClient,
  ICPLSelfServeDataImportSubmissionBundlesClient,
  CPLSelfServeDataImportSubmissionBundlesClient,
  ICPLSelfServeDataImportSubmissionLocksClient,
  CPLSelfServeDataImportSubmissionLocksClient,
  ICPLTypesClient,
  CPLTypesClient,
} from "services/api/cplapi/CPLAPI";
import {
  CPLAuthAuthenticationClient,
  CPLAuthClientPortalUsersClient,
  CPLAuthCompanyBrandingClient,
  CPLAuthDirectorsClient,
  CPLAuthGoCardlessClient,
  CPLAuthImpersonationClient,
  CPLAuthLicenceClient,
  CPLAuthMaintenanceClient,
  CPLAuthPermissionsClient,
  CPLAuthTestClient,
  CPLAuthUserGroupClient,
  CPLAuthUserMigrationClient,
  CPLAuthUsersClient,
  ICPLAuthAuthenticationClient,
  ICPLAuthClientPortalUsersClient,
  ICPLAuthCompanyBrandingClient,
  ICPLAuthDirectorsClient,
  ICPLAuthGoCardlessClient,
  ICPLAuthImpersonationClient,
  ICPLAuthLicenceClient,
  ICPLAuthMaintenanceClient,
  ICPLAuthPermissionsClient,
  ICPLAuthTestClient,
  ICPLAuthUserGroupClient,
  ICPLAuthUserMigrationClient,
  ICPLAuthUsersClient,
} from "services/api/cplauthapi/CPLAuthAPI";
import { AuthenticationService, IAuthenticationService } from "services/AuthenticationService";
import { ExampleService, ExampleService2, IExampleService, IExampleService2 } from "services/ExampleService";
import { ILicenceService, LicenceService } from "services/LicenceService";
import { ISessionService, SessionService } from "services/SessionService";
import { IAuthUsersService, AuthUsersService } from "services/AuthUsersService";
import { SERVICE_TYPES } from "./ServiceTypes";
import { IStandardDescriptionsService, StandardDescriptionService } from "services/StandardDescriptionsService";
import { DevelopmentsService, IDevelopmentsService } from "services/DevelopmentsService";
import { ClientsService, IClientsService } from "services/ClientsService";
import { IJobTypesService, JobTypesService } from "services/JobTypesService";
import { CountriesService, ICountriesService } from "services/CountriesService";
import { ILegalEntitiesService, LegalEntitiesService } from "services/LegalEntitiesService";
import {
  IPurchaseAccountInformationService,
  PurchaseAccountInformationService,
} from "services/PurchaseAccountInformationService";
import { IUsersService, UsersService } from "services/UsersService";
import { DocumentTypesService, IDocumentTypesService } from "services/DocumentTypesService";
import { DocumentSubTypesService, IDocumentSubTypesService } from "services/DocumentSubTypesService";
import { ISLATypesService, SLATypesService } from "services/SLATypesService";
import { IUserSettingsService, UserSettingsService } from "services/UserSettingsService";
import { IUserTasksService, UserTasksService } from "services/UserTasksService";
import { IUserGroupsService, UserGroupsService } from "services/UserGroupsService";
import { IWorkingHoursService, WorkingHoursService } from "services/WorkingHoursService";
import { ChangeTrackingService, IChangeTrackingService } from "services/ChangeTrackingService";
import { ISystemInfoService, SystemInfoService } from "services/SystemInfoService";
import { CalendarEventService, ICalendarEventService } from "services/CalendarEventService";
import { IUsersSupervisorsService, UsersSupervisorsService } from "services/UsersSupervisorsService";
import { ITextEditorImageUploadService, TextEditorImageUploadService } from "services/TextEditorImageUploadService";
import { CaseTypesService, ICaseTypesService } from "services/CaseTypesService";
import { CaseStatusTypesService, ICaseStatusTypesService } from "services/CaseStatusTypesService";
import { CasesService, ICasesService } from "services/CasesService";
import { MeetingTypesService, IMeetingTypesService } from "services/MeetingTypesService";
import { MeetingsService, IMeetingsService } from "services/MeetingsService";
import { DirectorsService, IDirectorsService } from "services/DirectorsService";
import { AddressesService, IAddressesService } from "services/AddressesService";
import { CommentsService, ICommentsService } from "services/CommentsService";
import { DataImportService, IDataImportService } from "services/DataImportService";
import { CPLCoreConnectService, ICPLCoreConnectService } from "services/CPLCoreConnectService";
import { ClientPortalUsersService, IClientPortalUsersService } from "services/ClientPortalUsersService";
import { DashboardService, IDashboardService } from "services/DashboardService";
import { IJobsService, JobsService } from "services/JobsService";
import { EstimatesService, IEstimatesService } from "services/EstimatesService";
import { ISettingsService, SettingsService } from "services/SettingsService";
import { IPermissionsService, PermissionsService } from "services/PermissionsService";
import { CompanyBrandingService, ICompanyBrandingService } from "services/CompanyBrandingService";
import { IUserMigrationService, UserMigrationService } from "services/UserMigrationService";
import { IPaymentProvidersService, PaymentProvidersService } from "services/PaymentProvidersService";
import { GoCardlessService, IGoCardlessService } from "services/GoCardlessService";
import { IPowerBIService, PowerBIService } from "services/PowerBIService";
import { ITestService, TestService } from "services/TestService";
import { BackgroundServiceService, IBackgroundServiceService } from "services/BackgroundServiceService";
import { AuthTestService, IAuthTestService } from "services/AuthTestService";
import { AIAssistantService, IAIAssistantService } from "services/AIAssistantService";
import { AIInvoicesService, IAIInvoicesService } from "services/AIInvoicesService";
import { IMaintenanceService, MaintenanceService } from "services/MaintenanceService";
import { IWebNarrativesService, WebNarrativesService } from "services/WebNarrativesService";
import { ICPLSettingsService, CPLSettingsService } from "services/CPLSettingsService";
import {
  DirectDebitCollectionDaysService,
  IDirectDebitCollectionDaysService,
} from "services/DirectDebitCollectionDaysService";
import { IServiceChargeInvoicingService, ServiceChargeInvoicingService } from "services/ServiceChargeInvoicingService";
import { IResumableProcessService, ResumableProcessService } from "services/ResumableProcessService";
import {
  IServiceChargeInvoiceSettingsService,
  ServiceChargeInvoiceSettingsService,
} from "services/ServiceChargeInvoiceSettingsService";
import { BlocksService, IBlocksService } from "services/BlocksService";
import { FundSchedulesService, IFundSchedulesService } from "services/FundSchedulesService";
import {
  AnticipatedExpenditureReportService,
  IAnticipatedExpenditureReportService,
} from "services/AnticipatedExpenditureReportService";
import {
  IServiceChargeInvoicingSummariesService,
  ServiceChargeInvoicingSummariesService,
} from "services/ServiceChargeInvoicingSummariesService";
import { FundHeaderService, IFundHeaderService } from "services/FundHeaderService";
import { IImpersonationService, ImpersonationService } from "services/ImpersonationService";

const container = new Container();

// cpl auth api clients
container.bind<ICPLAuthAuthenticationClient>(SERVICE_TYPES.CPLAuthAuthenticationClient).to(CPLAuthAuthenticationClient);
container.bind<ICPLAuthUsersClient>(SERVICE_TYPES.CPLAuthUsersClient).to(CPLAuthUsersClient);
container.bind<ICPLAuthLicenceClient>(SERVICE_TYPES.CPLAuthLicenceClient).to(CPLAuthLicenceClient);
container.bind<ICPLAuthUserGroupClient>(SERVICE_TYPES.CPLAuthUserGroupsClient).to(CPLAuthUserGroupClient);
container.bind<ICPLAuthGoCardlessClient>(SERVICE_TYPES.CPLAuthGoCardlessClient).to(CPLAuthGoCardlessClient);
container.bind<ICPLAuthTestClient>(SERVICE_TYPES.CPLAuthTestClient).to(CPLAuthTestClient);
container
  .bind<ICPLAuthCompanyBrandingClient>(SERVICE_TYPES.CPLAuthCompanyBrandingClient)
  .to(CPLAuthCompanyBrandingClient);
container.bind<ICPLAuthPermissionsClient>(SERVICE_TYPES.CPLAuthPermissionsClient).to(CPLAuthPermissionsClient);
container.bind<ICPLAuthUserMigrationClient>(SERVICE_TYPES.CPLAuthUserMigrationClient).to(CPLAuthUserMigrationClient);
container.bind<ICPLAuthMaintenanceClient>(SERVICE_TYPES.CPLAuthMaintenanceClient).to(CPLAuthMaintenanceClient);
container
  .bind<ICPLAuthClientPortalUsersClient>(SERVICE_TYPES.CPLAuthClientPortalUsersClient)
  .to(CPLAuthClientPortalUsersClient);
container.bind<ICPLAuthDirectorsClient>(SERVICE_TYPES.CPLAuthDirectorsClient).to(CPLAuthDirectorsClient);
container.bind<ICPLAuthImpersonationClient>(SERVICE_TYPES.CPLAuthImpersonationClient).to(CPLAuthImpersonationClient);

// cpl api clients
container.bind<ICPLDevelopmentsClient>(SERVICE_TYPES.CPLDevelopmentsClient).to(CPLDevelopmentsClient);
container
  .bind<ICPLStandardDescriptionsClient>(SERVICE_TYPES.CPLStandardDescriptionsClient)
  .to(CPLStandardDescriptionsClient);
container.bind<ICPLFundSchedulesClient>(SERVICE_TYPES.CPLFundSchedulesClient).to(CPLFundSchedulesClient);
container.bind<ICPLBlocksClient>(SERVICE_TYPES.CPLBlocksClient).to(CPLBlocksClient);
container.bind<ICPLClientsClient>(SERVICE_TYPES.CPLClientsClient).to(CPLClientsClient);
container.bind<ICPLJobTypesClient>(SERVICE_TYPES.CPLJobTypesClient).to(CPLJobTypesClient);
container.bind<ICPLLegalEntitiesClient>(SERVICE_TYPES.CPLLegalEntitiesClient).to(CPLLegalEntitiesClient);
container
  .bind<ICPLPurchaseAccountInformationClient>(SERVICE_TYPES.CPLPurchaseAccountInformationClient)
  .to(CPLPurchaseAccountInformationClient);
container.bind<ICPLUsersClient>(SERVICE_TYPES.CPLUsersClient).to(CPLUsersClient);
container.bind<ICPLDocumentTypesClient>(SERVICE_TYPES.CPLDocumentTypesClient).to(CPLDocumentTypesClient);
container.bind<ICPLDocumentSubTypesClient>(SERVICE_TYPES.CPLDocumentSubTypesClient).to(CPLDocumentSubTypesClient);
container.bind<ICPLSLATypesClient>(SERVICE_TYPES.CPLSLATypesClient).to(CPLSLATypesClient);
container.bind<ICPLUserTasksClient>(SERVICE_TYPES.CPLUserTasksClient).to(CPLUserTasksClient);
container.bind<ICPLWorkingHoursClient>(SERVICE_TYPES.CPLWorkingHoursClient).to(CPLWorkingHoursClient);
container.bind<ICPLChangeTrackingClient>(SERVICE_TYPES.CPLChangeTrackingClient).to(CPLChangeTrackingClient);
container.bind<ICPLSystemInfoClient>(SERVICE_TYPES.CPLSystemInfoClient).to(CPLSystemInfoClient);
container.bind<ICPLAuthenticationClient>(SERVICE_TYPES.CPLAuthenticationClient).to(CPLAuthenticationClient);
container.bind<ICPLCalendarEventsClient>(SERVICE_TYPES.CPLCalendarEventsClient).to(CPLCalendarEventsClient);
container.bind<ICPLUsersSupervisorsClient>(SERVICE_TYPES.CPLUsersSupervisorsClient).to(CPLUsersSupervisorsClient);
container
  .bind<ICPLTextEditorImageUploadClient>(SERVICE_TYPES.CPLTextEditorImageUploadClient)
  .to(CPLTextEditorImageUploadClient);
container.bind<ICPLCaseTypesClient>(SERVICE_TYPES.CPLCaseTypesClient).to(CPLCaseTypesClient);
container.bind<ICPLCaseStatusTypesClient>(SERVICE_TYPES.CPLCaseStatusTypesClient).to(CPLCaseStatusTypesClient);
container.bind<ICPLCasesClient>(SERVICE_TYPES.CPLCasesClient).to(CPLCasesClient);
container.bind<ICPLMeetingsClient>(SERVICE_TYPES.CPLMeetingsClient).to(CPLMeetingsClient);
container.bind<ICPLDirectorsClient>(SERVICE_TYPES.CPLDirectorsClient).to(CPLDirectorsClient);
container.bind<ICPLAddressesClient>(SERVICE_TYPES.CPLAddressesClient).to(CPLAddressesClient);
container.bind<ICPLMeetingTypesClient>(SERVICE_TYPES.CPLMeetingTypesClient).to(CPLMeetingTypesClient);
container.bind<ICPLCommentsClient>(SERVICE_TYPES.CPLCommentsClient).to(CPLCommentsClient);
container.bind<ICPLCPLCoreConnectClient>(SERVICE_TYPES.CPLCPLCoreConnectClient).to(CPLCPLCoreConnectClient);
container.bind<ICPLDashboardClient>(SERVICE_TYPES.CPLDashboardClient).to(CPLDashboardClient);
container.bind<ICPLJobsClient>(SERVICE_TYPES.CPLJobsClient).to(CPLJobsClient);
container.bind<ICPLEstimatesClient>(SERVICE_TYPES.CPLEstimatesClient).to(CPLEstimatesClient);
container.bind<ICPLSettingsClient>(SERVICE_TYPES.CPLSettingsClient).to(CPLSettingsClient);
container.bind<ICPLPaymentProvidersClient>(SERVICE_TYPES.CPLPaymentProvidersClient).to(CPLPaymentProvidersClient);
container.bind<ICPLPowerBIClient>(SERVICE_TYPES.CPLPowerBIClient).to(CPLPowerBIClient);
container.bind<ICPLTestClient>(SERVICE_TYPES.CPLTestClient).to(CPLTestClient);
container.bind<ICPLBackgroundServiceClient>(SERVICE_TYPES.CPLBackgroundServiceClient).to(CPLBackgroundServiceClient);
container.bind<ICPLAIChatClient>(SERVICE_TYPES.CPLAIChatClient).to(CPLAIChatClient);
container.bind<ICPLAIInvoicesClient>(SERVICE_TYPES.CPLAIInvoicesClient).to(CPLAIInvoicesClient);
container.bind<ICPLWebNarrativesClient>(SERVICE_TYPES.CPLWebNarrativesClient).to(CPLWebNarrativesClient);
container.bind<ICPLCPL3SettingsClient>(SERVICE_TYPES.CPLCPL3SettingsClient).to(CPLCPL3SettingsClient);
container
  .bind<ICPLDirectDebitCollectionDaysClient>(SERVICE_TYPES.CPLDirectDebitCollectionDaysClient)
  .to(CPLDirectDebitCollectionDaysClient);
container.bind<ICPLResumableProcessClient>(SERVICE_TYPES.CPLResumableProcessClient).to(CPLResumableProcessClient);
container
  .bind<ICPLServiceChargeInvoicingClient>(SERVICE_TYPES.CPLServiceChargeInvoicingClient)
  .to(CPLServiceChargeInvoicingClient);
container
  .bind<ICPLServiceChargeInvoicingSettingsClient>(SERVICE_TYPES.CPLServiceChargeInvoicingSettingsClient)
  .to(CPLServiceChargeInvoicingSettingsClient);
container
  .bind<ICPLAnticipatedExpenditureClient>(SERVICE_TYPES.CPLAnticipatedExpenditureClient)
  .to(CPLAnticipatedExpenditureClient);
container
  .bind<ICPLServiceChargeInvoicingSummariesClient>(SERVICE_TYPES.CPLServiceChargeInvoicingSummariesClient)
  .to(CPLServiceChargeInvoicingSummariesClient);
container.bind<ICPLFundHeaderClient>(SERVICE_TYPES.CPLFundHeaderClient).to(CPLFundHeaderClient);
container
  .bind<ICPLSelfServeDataImportSubmissionsClient>(SERVICE_TYPES.CPLSelfServeDataImportSubmissionsClient)
  .to(CPLSelfServeDataImportSubmissionsClient);
container
  .bind<ICPLSelfServeDataImportSubmissionFilesClient>(SERVICE_TYPES.CPLSelfServeDataImportSubmissionFilesClient)
  .to(CPLSelfServeDataImportSubmissionFilesClient);
container
  .bind<ICPLSelfServeDataImportSubmissionSheetMappingsClient>(
    SERVICE_TYPES.CPLSelfServeDataImportSubmissionSheetMappingsClient
  )
  .to(CPLSelfServeDataImportSubmissionSheetMappingsClient);
container
  .bind<ICPLSelfServeDataImportSubmissionColumnMappingsClient>(
    SERVICE_TYPES.CPLSelfServeDataImportSubmissionColumnMappingsClient
  )
  .to(CPLSelfServeDataImportSubmissionColumnMappingsClient);
container
  .bind<ICPLSelfServeDataImportSubmissionValidationResultsClient>(
    SERVICE_TYPES.CPLSelfServeDataImportSubmissionValidationResultsClient
  )
  .to(CPLSelfServeDataImportSubmissionValidationResultsClient);
container
  .bind<ICPLSelfServeDataImportSubmissionEditsClient>(SERVICE_TYPES.CPLSelfServeDataImportSubmissionEditsClient)
  .to(CPLSelfServeDataImportSubmissionEditsClient);
container
  .bind<ICPLSelfServeDataImportSubmissionBundlesClient>(SERVICE_TYPES.CPLSelfServeDataImportSubmissionBundlesClient)
  .to(CPLSelfServeDataImportSubmissionBundlesClient);
container
  .bind<ICPLSelfServeDataImportSubmissionLocksClient>(SERVICE_TYPES.CPLSelfServeDataImportSubmissionLocksClient)
  .to(CPLSelfServeDataImportSubmissionLocksClient);
container.bind<ICPLTypesClient>(SERVICE_TYPES.CPLTypesClient).to(CPLTypesClient);

// services
container.bind<IExampleService>(SERVICE_TYPES.ExampleService).to(ExampleService);
container.bind<IExampleService2>(SERVICE_TYPES.ExampleService2).to(ExampleService2);
container.bind<IAuthenticationService>(SERVICE_TYPES.AuthenticationService).to(AuthenticationService);
container.bind<ISessionService>(SERVICE_TYPES.SessionService).to(SessionService);
container.bind<IAuthUsersService>(SERVICE_TYPES.AuthUsersService).to(AuthUsersService);
container.bind<ILicenceService>(SERVICE_TYPES.LicenceService).to(LicenceService);
container.bind<IDevelopmentsService>(SERVICE_TYPES.DevelopmentsService).to(DevelopmentsService);
container.bind<IStandardDescriptionsService>(SERVICE_TYPES.StandardDescriptionsService).to(StandardDescriptionService);
container.bind<IFundSchedulesService>(SERVICE_TYPES.FundSchedulesService).to(FundSchedulesService);
container.bind<IBlocksService>(SERVICE_TYPES.BlocksService).to(BlocksService);
container.bind<IClientsService>(SERVICE_TYPES.ClientsService).to(ClientsService);
container.bind<IJobTypesService>(SERVICE_TYPES.JobTypesService).to(JobTypesService);
container.bind<ICountriesService>(SERVICE_TYPES.CountriesService).to(CountriesService);
container.bind<ILegalEntitiesService>(SERVICE_TYPES.LegalEntitiesService).to(LegalEntitiesService);
container
  .bind<IPurchaseAccountInformationService>(SERVICE_TYPES.PurchaseAccountInformationService)
  .to(PurchaseAccountInformationService);
container.bind<IUsersService>(SERVICE_TYPES.UsersService).to(UsersService);
container.bind<IDocumentTypesService>(SERVICE_TYPES.DocumentTypesService).to(DocumentTypesService);
container.bind<IDocumentSubTypesService>(SERVICE_TYPES.DocumentSubTypesService).to(DocumentSubTypesService);
container.bind<ISLATypesService>(SERVICE_TYPES.SLATypesService).to(SLATypesService);
container.bind<IUserSettingsService>(SERVICE_TYPES.UserSettingsService).to(UserSettingsService);
container.bind<IUserTasksService>(SERVICE_TYPES.UserTasksService).to(UserTasksService);
container.bind<IUserGroupsService>(SERVICE_TYPES.UserGroupsService).to(UserGroupsService);
container.bind<IWorkingHoursService>(SERVICE_TYPES.WorkingHoursService).to(WorkingHoursService);
container.bind<IChangeTrackingService>(SERVICE_TYPES.ChangeTrackingService).to(ChangeTrackingService);
container.bind<ISystemInfoService>(SERVICE_TYPES.SystemInfoService).to(SystemInfoService);
container.bind<ICalendarEventService>(SERVICE_TYPES.CalendarEventService).to(CalendarEventService);
container.bind<IUsersSupervisorsService>(SERVICE_TYPES.UsersSupervisorsService).to(UsersSupervisorsService);
container
  .bind<ITextEditorImageUploadService>(SERVICE_TYPES.TextEditorImageUploadService)
  .to(TextEditorImageUploadService);
container.bind<ICommentsService>(SERVICE_TYPES.CommentsService).to(CommentsService);
container.bind<ICaseTypesService>(SERVICE_TYPES.CaseTypesService).to(CaseTypesService);
container.bind<ICaseStatusTypesService>(SERVICE_TYPES.CaseStatusTypesService).to(CaseStatusTypesService);
container.bind<ICasesService>(SERVICE_TYPES.CasesService).to(CasesService);
container.bind<IMeetingsService>(SERVICE_TYPES.MeetingsService).to(MeetingsService);
container.bind<IDirectorsService>(SERVICE_TYPES.DirectorsService).to(DirectorsService);
container.bind<IAddressesService>(SERVICE_TYPES.AddressesService).to(AddressesService);
container.bind<IMeetingTypesService>(SERVICE_TYPES.MeetingTypesService).to(MeetingTypesService);
container.bind<ICPLCoreConnectService>(SERVICE_TYPES.CPLCoreConnectService).to(CPLCoreConnectService);
container.bind<IClientPortalUsersService>(SERVICE_TYPES.ClientPortalUsersService).to(ClientPortalUsersService);
container.bind<IDashboardService>(SERVICE_TYPES.DashboardService).to(DashboardService);
container.bind<IJobsService>(SERVICE_TYPES.JobsService).to(JobsService);
container.bind<IEstimatesService>(SERVICE_TYPES.EstimatesService).to(EstimatesService);
container.bind<ISettingsService>(SERVICE_TYPES.SettingsService).to(SettingsService);
container.bind<IPermissionsService>(SERVICE_TYPES.PermissionService).to(PermissionsService);
container.bind<ICompanyBrandingService>(SERVICE_TYPES.CompanyBrandingService).to(CompanyBrandingService);
container.bind<IUserMigrationService>(SERVICE_TYPES.UserMigrationService).to(UserMigrationService);
container.bind<IPaymentProvidersService>(SERVICE_TYPES.PaymentProvidersService).to(PaymentProvidersService);
container.bind<IGoCardlessService>(SERVICE_TYPES.GoCardlessService).to(GoCardlessService);
container.bind<IPowerBIService>(SERVICE_TYPES.PowerBIService).to(PowerBIService);
container.bind<ITestService>(SERVICE_TYPES.TestService).to(TestService);
container.bind<IBackgroundServiceService>(SERVICE_TYPES.BackgroundServiceService).to(BackgroundServiceService);
container.bind<IAuthTestService>(SERVICE_TYPES.AuthTestService).to(AuthTestService);
container.bind<IAIAssistantService>(SERVICE_TYPES.AIAssistantService).to(AIAssistantService);
container.bind<IAIInvoicesService>(SERVICE_TYPES.AIInvoicesService).to(AIInvoicesService);
container.bind<IMaintenanceService>(SERVICE_TYPES.MaintenanceService).to(MaintenanceService);
container.bind<IWebNarrativesService>(SERVICE_TYPES.WebNarrativesService).to(WebNarrativesService);
container.bind<ICPLSettingsService>(SERVICE_TYPES.CPLSettingsService).to(CPLSettingsService);
container
  .bind<IDirectDebitCollectionDaysService>(SERVICE_TYPES.DirectDebitCollectionDaysService)
  .to(DirectDebitCollectionDaysService);
container.bind<IResumableProcessService>(SERVICE_TYPES.ResumableProcessService).to(ResumableProcessService);
container
  .bind<IServiceChargeInvoicingService>(SERVICE_TYPES.ServiceChargeInvoicingService)
  .to(ServiceChargeInvoicingService);
container
  .bind<IServiceChargeInvoiceSettingsService>(SERVICE_TYPES.ServiceChargeInvoiceSettingsService)
  .to(ServiceChargeInvoiceSettingsService);
container
  .bind<IAnticipatedExpenditureReportService>(SERVICE_TYPES.AnticipatedExpenditureReportService)
  .to(AnticipatedExpenditureReportService);
container
  .bind<IServiceChargeInvoicingSummariesService>(SERVICE_TYPES.ServiceChargeInvoicingSummariesService)
  .to(ServiceChargeInvoicingSummariesService);
container.bind<IFundHeaderService>(SERVICE_TYPES.FundHeaderService).to(FundHeaderService);
container.bind<IImpersonationService>(SERVICE_TYPES.ImpersonationService).to(ImpersonationService);
container.bind<IDataImportService>(SERVICE_TYPES.DataImportService).to(DataImportService);

export { container };
